import React from "react";

const ProductInfo = ({ productInfo }) => {
  return (
    <div className="flex flex-col gap-5">
      <h2 className="text-4xl font-semibold">{productInfo.productName}</h2>
      <p className="text-xl font-semibold">${productInfo.price}</p>
      <p className="text-base text-gray-600">{productInfo.des}</p>
      <p className="text-sm">Be the first to leave a review.</p>
      <p className="font-medium text-lg">
        <span className="font-normal">Colors:</span> {productInfo.color}
      </p>

      {/* WhatsApp Enquiry Button */}
      <a
        href="https://wa.me/971542660433"
        target="_blank"
        rel="noopener noreferrer"
        className="w-full py-4 bg-primeColor hover:bg-green-600 duration-300 text-white text-lg font-titleFont text-center rounded-md"
      >
        Enquire on WhatsApp
      </a>

      <p className="font-normal text-sm">
        <span className="text-base font-medium">Categories:</span> Spring
        collection, Streetwear, Women Tags: featured SKU: N/A
      </p>
    </div>
  );
};

export default ProductInfo;